import {
	CITY_OBJCT,
	CHECK_DATE_OBJECT
} from './object-types.js'


export default {
	// 记录当前城市
	[CITY_OBJCT](state, {city_object}) {
		state.city_object = city_object;
	},
	[CHECK_DATE_OBJECT](state, {date_object}) {
		state.date_object = date_object;
	}
}



// WEBPACK FOOTER //
// ./src/store/mutations.js